import { useRef } from "react";

const SWIPE_THRESHOLD_PX = 38;

/** Pointer handlers that turn a horizontal swipe into a rotation and swallow the click it ends with. */
export function useSwipe(onSwipe) {
  const startX = useRef(null);
  const swallowClick = useRef(false);

  return {
    onPointerDown: (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      startX.current = event.clientX;
    },
    onPointerUp: (event) => {
      if (startX.current === null) return;
      const distance = event.clientX - startX.current;
      startX.current = null;
      if (Math.abs(distance) < SWIPE_THRESHOLD_PX) return;
      swallowClick.current = true;
      onSwipe(distance < 0 ? 1 : -1);
      window.setTimeout(() => {
        swallowClick.current = false;
      }, 250);
    },
    onPointerCancel: () => {
      startX.current = null;
    },
    onClickCapture: (event) => {
      if (!swallowClick.current) return;
      event.preventDefault();
      event.stopPropagation();
      swallowClick.current = false;
    },
  };
}
